export const STATUS_TRANSLATOR = {
	pend: 'در انتظار تسویه',
	done: 'تسویه شده',
};
